import { createReducer } from 'utils/helpers';
import { FastEntryActionTypes, IActions } from './FastEntry.actions';
import { IFastLineDetails, ILastChangedField } from './FastEntry.properties';
import { InitialState } from './FastEntry.constants';

export interface IState {
  isLoading: boolean;
  quantity: number;
  price: number;
  product?: number;
  purchaseOrder?: { PurchaseOrder: string; LineNumber: number };
  packageId?: number;
  matchType: string;
  productDisplay: string;
  productDescription: string;
  nonProductFieldsDisabled: boolean;
  fastLineDetails?: IFastLineDetails;
  lastChangedField?: ILastChangedField;
  priceDisabled: boolean;
  isInvalidProduct: boolean;
  apply: boolean;
  disablePurchaseOrderLookup: boolean;
}

type IAction = (state: IState, payload: any) => IState;

type IActionMap = Record<FastEntryActionTypes, IAction>;

const actionMap: IActionMap = {
  [FastEntryActionTypes.setLoading]: (state: IState, payload: IState['isLoading']): IState => ({ ...state, isLoading: payload }),
  [FastEntryActionTypes.setQuantity]: (state: IState, payload: IState['quantity']): IState => ({ ...state, quantity: payload }),
  [FastEntryActionTypes.setPrice]: (state: IState, payload: IState['price']): IState => ({ ...state, price: payload }),
  [FastEntryActionTypes.setProduct]: (state: IState, payload: IState['product']): IState => ({ ...state, product: payload }),
  [FastEntryActionTypes.setPackageId]: (state: IState, payload: IState['packageId']): IState => ({ ...state, packageId: payload }),
  [FastEntryActionTypes.setMatchType]: (state: IState, payload: IState['matchType']): IState => ({ ...state, matchType: payload }),
  [FastEntryActionTypes.setProductDisplay]: (state: IState, payload: IState['productDisplay']): IState => ({ ...state, productDisplay: payload }),
  [FastEntryActionTypes.setProductDescription]: (state: IState, payload: IState['productDescription']): IState => ({ ...state, productDescription: payload }),
  [FastEntryActionTypes.setNonProductFieldsDisabled]: (state: IState, payload: IState['nonProductFieldsDisabled']): IState => ({ ...state, nonProductFieldsDisabled: payload }),
  [FastEntryActionTypes.setPurchaseOrder]: (state: IState, payload: IState['purchaseOrder']): IState => ({ ...state, purchaseOrder: payload }),
  [FastEntryActionTypes.setFastLineDetails]: (state: IState, payload: IState['fastLineDetails']): IState => ({ ...state, fastLineDetails: payload }),
  [FastEntryActionTypes.setLastChangedField]: (state: IState, payload: IState['lastChangedField']): IState => ({ ...state, lastChangedField: payload }),
  [FastEntryActionTypes.setPriceDisabled]: (state: IState, payload: IState['priceDisabled']): IState => ({ ...state, priceDisabled: payload }),
  [FastEntryActionTypes.setIsInvalidProduct]: (state: IState, payload: IState['isInvalidProduct']): IState => ({ ...state, isInvalidProduct: payload }),
  [FastEntryActionTypes.setApply]: (state: IState, payload: IState['apply']): IState => ({ ...state, apply: payload }),
  [FastEntryActionTypes.setDisablePurchaseOrderLookup]: (state: IState, payload: IState['disablePurchaseOrderLookup']): IState => ({ ...state, disablePurchaseOrderLookup: payload }),
  [FastEntryActionTypes.resetToDefault]: (state: IState): IState => ({ ...state, ...InitialState }),
};

export default createReducer<IActionMap, IState, IActions>(actionMap);
